import {zDateTime, zNumberToString} from '@brunata-angular/util';
import {z} from 'zod';

export const alarms: readonly {type: string; translationKey: string}[] = [
    {type: 'R', translationKey: 'titles_humidity'},
    {type: 'RT', translationKey: 'titles_runningToilet'},
    {type: 'C', translationKey: 'titles_temperature'},

    {type: '5', translationKey: 'titles_defective-hardware-alarm'},
    {type: '6', translationKey: 'titles_leakage'},
    {type: '2', translationKey: 'titles_lowBattery'},
    {type: '64', translationKey: 'titles_dismounted'},
    {type: '63', translationKey: 'titles_continuousFlow'},
];

export const notificationSchema = z
    .object({
        emailLogId: z.number(),
        variableAlarmType: z.string().nullable(),
        eventNotificationType: zNumberToString.nullable(),
        isConsumptionAgent: z.boolean(),
        name: z.string().nullable(),
        notificationSent: zDateTime,
        recipientEmails: z.string(),
    })
    .transform(data => {
        const combinedType = data.variableAlarmType ?? data.eventNotificationType;
        const translationKey = data.isConsumptionAgent
            ? 'consumption-agents_consumption-agent'
            : (alarms.find(alarm => alarm.type === combinedType)?.translationKey ?? null);
        const module = data.isConsumptionAgent ? 'ngonline' : 'monitoringAlarms';
        return {
            ...data,
            combinedType,
            translationKey,
            module,
        };
    });

export type NotificationItem = z.infer<typeof notificationSchema>;
